import React, { useState } from 'react';
import { Box, Container, Stack, TextField } from '@mui/material';

const ReviewNotes: React.FC<{
  label: string;
  labelAdornment?: React.ReactNode;
  reviewNotes: string | null;
  setReviewNotes?: (reviewNotes: string) => void;
}> = ({ label, labelAdornment, reviewNotes, setReviewNotes }) => {
  const [isEntered, setIsEntered] = useState(false);

  const labelComponent =
    reviewNotes || isEntered ? (
      <Stack direction='row' alignItems='flex-start' justifyContent='space-between' spacing={2}>
        <Box sx={{ flex: 1 }}>{label}</Box>
        {labelAdornment}
      </Stack>
    ) : (
      label
    );

  return (
    <Container maxWidth={false} disableGutters={true} sx={{ margin: '0', marginBottom: '16px' }}>
      <TextField
        label={labelComponent}
        multiline={false}
        fullWidth={true}
        value={reviewNotes ? reviewNotes : ''} // Workaround for label not moving on initial value set
        disabled={setReviewNotes === undefined}
        onChange={event => setReviewNotes?.(event.target.value)}
        onFocus={() => setIsEntered(true)}
        onBlur={() => setIsEntered(false)}
      />
    </Container>
  );
};

export default ReviewNotes;
